import { QueryKey, replaceEqualDeep } from '@tanstack/react-query';

export const structuralSharing = <data>(oldData: data | undefined, newData: data): data => {
  return replaceEqualDeep(oldData, newData);
};

export const hashFn = (queryKey: QueryKey): string => {
  return JSON.stringify(queryKey, (_, value) => {
    if (isPlainObject(value))
      return Object.keys(value)
        .sort()
        .reduce((result, key) => {
          //@ts-ignore
          result[key] = value[key];
          return result;
        }, {} as any);
    if (typeof value === 'bigint') return value.toString();
    return value;
  });
};

const isPlainObject = (value: any): value is object => {
  if (!hasObjectPrototype(value)) {
    return false;
  }

  // If has modified constructor
  const ctor = value.constructor;
  if (typeof ctor === 'undefined') return true;

  // If has modified prototype
  const prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) return false;

  // If constructor does not have an Object-specific method
  if (!Object.prototype.hasOwnProperty.call(prot, 'isPrototypeOf')) return false;

  // Most likely a plain Object
  return true;
};

const hasObjectPrototype = (o: any): boolean => {
  return Object.prototype.toString.call(o) === '[object Object]';
};
